import React from 'react';
import { Calendar, MapPin, Clock, Laptop, Wifi, Globe, CheckCircle } from 'lucide-react';
export function CourseDetails() {
  return <section className="mb-12" data-id="element-178">
      <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-179">Course Details</h2>

      {/* Course Format */}
      <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 mb-8 border border-blue-100" data-id="element-180">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-181">Course Format</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-182">
          <div className="flex items-start gap-3" data-id="element-183">
            <Clock className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-184" />
            <div data-id="element-185">
              <p className="font-semibold text-gray-900" data-id="element-186">Duration</p>
              <p className="text-gray-700" data-id="element-187">8 weeks</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-188">
            <MapPin className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-189" />
            <div data-id="element-190">
              <p className="font-semibold text-gray-900" data-id="element-191">Location</p>
              <p className="text-gray-700" data-id="element-192">Virtual</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-193">
            <Calendar className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-194" />
            <div data-id="element-195">
              <p className="font-semibold text-gray-900" data-id="element-196">Format</p>
              <p className="text-gray-700" data-id="element-197">Self-paced, cohort-based</p>
            </div>
          </div>
        </div>
      </div>

      {/* Course Requirements */}
      <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-8 mb-8 border border-green-100" data-id="element-198">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-199">
          Course Requirements
        </h3>
        <div className="space-y-4" data-id="element-200">
          <div className="flex items-start gap-3" data-id="element-201">
            <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-202" />
            <p className="text-gray-700" data-id="element-203">
              Commitment to coursework within duration of programme
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-204">
            <Laptop className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-205" />
            <p className="text-gray-700" data-id="element-206">
              Device: PC or laptop recommended (Windows 10+/macOS latest);
              smartphones may be used for some activities
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-207">
            <Wifi className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-208" />
            <p className="text-gray-700" data-id="element-209">
              Reliable internet connection for live sessions
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-210">
            <Globe className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-211" />
            <p className="text-gray-700" data-id="element-212">
              Compatible browsers: latest Google Chrome, Firefox, Edge, or
              Safari
            </p>
          </div>
        </div>
      </div>

      {/* Target Audience */}
      <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100" data-id="element-213">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-214">
          Who Should Enroll?
        </h3>
        <p className="text-gray-700 mb-4" data-id="element-215">This course is perfect for:</p>
        <div className="space-y-3" data-id="element-216">
          <div className="flex items-start gap-3" data-id="element-217">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-218"></div>
            <p className="text-gray-700" data-id="element-219">
              <span className="font-semibold" data-id="element-220">
                Aspiring Executive Assistants
              </span>{' '}
              looking to break into high-level admin and executive support roles
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-221">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-222"></div>
            <p className="text-gray-700" data-id="element-223">
              <span className="font-semibold" data-id="element-224">
                Administrative Professionals & Secretaries
              </span>{' '}
              seeking promotion into more strategic roles
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-225">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-226"></div>
            <p className="text-gray-700" data-id="element-227">
              <span className="font-semibold" data-id="element-228">Personal Assistants</span> ready
              to upskill and earn more
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-229">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-230"></div>
            <p className="text-gray-700" data-id="element-231">
              <span className="font-semibold" data-id="element-232">Office Managers</span>{' '}
              transitioning into EA roles
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-233">
            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-234"></div>
            <p className="text-gray-700" data-id="element-235">
              <span className="font-semibold" data-id="element-236">Recent graduates</span> targeting
              remote or hybrid EA job roles
            </p>
          </div>
        </div>
      </div>
    </section>;
}